module.exports = __webpack_public_path__ + "img/sci-fi-ui.bc623fa4.jpg";